export const navigation = {
  categories: [
    {
      id: 'seasonal_fruits',
      name: 'Seasonal Fruits',
      featured: [],
      sections: [
        {
          id: 'seasonal_produce',
          name: 'Seasonal Produce',
          items: []
        },
      ],
    },
    {
      id: 'tropical_fruits',
      name: 'Tropical Fruits',
      featured: [],
      sections: [
        {
          id: 'fresh_fruits',
          name: 'Fresh Fruits',
          items: []
        },
      ],
    },
  ],
  pages: [
    // { name: 'Company', id: '/' },
    // { name: 'Stores', id: '/' },
  ],
}